var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 23.7386L14.6145 10.0557L14.6305 10.0685L23.0929 0.261475H20.265L13.3713 8.24369L7.89684 0.261475H0.480213L9.24251 13.0362L9.24144 13.0352L0 23.7386H2.82792L10.4921 14.8578L16.5834 23.7386H24ZM6.77634 2.39576L19.9449 21.6043H17.7039L4.52468 2.39576H6.77634Z",
    fill: "#0B6EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.7c98db852af54c9eb877f8d3281d920d.svg";
export { ForwardRef as ReactComponent };